import { ExportIcon, XIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { isIos, isStandalone } from '../../lib/media';

const KEY = 'regia-install-dismissed';

function dismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Sull'iPhone, in Safari: spiega come aggiungere Regia alla schermata Home (serve per le notifiche). */
export function InstallBanner() {
  const [hidden, setHidden] = useState(() => dismissed() || !isIos() || isStandalone());
  if (hidden) return null;
  return (
    <div className="mb-6 flex items-start gap-3 rounded-[var(--radius-sheet)] bg-ink p-4 text-sheet">
      <ExportIcon size={24} className="mt-0.5 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1 text-[0.9375rem]">
        Metti Regia sulla schermata Home: tocca <span className="font-semibold">Condividi</span>,
        poi <span className="font-semibold">Aggiungi alla schermata Home</span>. Così si apre come
        un’app e ricevi le notifiche.
      </p>
      <button
        type="button"
        aria-label="Chiudi"
        onClick={() => {
          try {
            localStorage.setItem(KEY, '1');
          } catch {
            // va bene anche solo per questa visita
          }
          setHidden(true);
        }}
        className="-mt-2 -mr-2 inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-white/10"
      >
        <XIcon size={18} aria-hidden />
      </button>
    </div>
  );
}
